import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import { injectIntl, intlShape, FormattedMessage } from "react-intl";
import { compose } from "recompose";
import { reduxForm, SubmissionError } from "redux-form";
import { postMessage } from "actions/messagingActions";
import { Button } from "cxa-components";
import messagesDescription from "components/messagesDescription";
import { StringField } from "cxa-form-field";
import { isExist, isEmpty } from "cxa-utils";
import DocumentFileUpload from "./DocumentFileUpload";

export const formName = "ComposeMessageForm";

class ComposeMessageForm extends PureComponent {
  static propTypes = {
    intl: intlShape.isRequired,
    className: PropTypes.string,
    parentMessage: PropTypes.object,
    subject: PropTypes.string,
    isReplyMessage: PropTypes.bool,
    isComposeMessage: PropTypes.bool,
    submitting: PropTypes.bool,
    isNarrowScreen: PropTypes.bool,
    error: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    onCancel: PropTypes.func,
    submitFailed: PropTypes.func,
    onReplyMessage: PropTypes.func,
    handleSubmit: PropTypes.func,
    onPostMessageSuccess: PropTypes.func,
  };

  state = {
    subject: null,
    messages: null,
    hasFiles: false,
    enableToSend: false,
  };

  render() {
    const { enableToSend } = this.state;
    const {
      className: clsForm,
      subject = "",
      isReplyMessage,
      handleSubmit,
      submitting,
      onReplyMessage,
      isComposeMessage,
      dirty,
      isNarrowScreen,
    } = this.props;

    const clsTextArea = cx("message-body__active", {
      "message-body__active--reply": isReplyMessage,
    });

    const notToSend = !isReplyMessage && !isComposeMessage;

    return (
      <form className={clsForm} onSubmit={handleSubmit}>
        {isComposeMessage && (
          <StringField
            name="subject"
            className="message-subject"
            label={<FormattedMessage {...messagesDescription.inAppMessages.subjectText} />}            
            onChange={this.handleChangeSubject}
            inlineBoxed
          />
        )}

        {isReplyMessage && (
          <div className="message-subject__read-only">
            <FormattedMessage {...messagesDescription.inAppMessages.subject} values={{ subject }} />
          </div>
        )}

        {(isReplyMessage || isComposeMessage) && (
          <StringField
            name="text"
            className={clsTextArea}
            onChange={this.handleChangeMessages}
            multiLine
          />
        )}

        {!isReplyMessage &&
          !isComposeMessage && (
            <Button tertiary onClick={onReplyMessage}>
              <FormattedMessage {...messagesDescription.inAppMessages.clickToNewMessage} />
            </Button>
          )}

        <DocumentFileUpload
          name="attachments"
          isClearFiles={notToSend || !dirty}
          disabled={notToSend}
          onChange={this.handleChangeFiles}
        />

        {!isNarrowScreen && [
          <Button primary key="send" disabled={notToSend || !enableToSend} submitting={submitting}>
            <FormattedMessage {...messagesDescription.inAppMessages.messageSendBtn} />
          </Button>,
          <Button
            key="cancel"
            disabled={notToSend}
            submitting={submitting}
            onClick={this.handleCancel}
            secondary
          >
            <FormattedMessage {...messagesDescription.cancelTextDescription} />
          </Button>,
        ]}
      </form>
    );
  }

  /**
   * Check all fileds after saving
   */
  checkFields = () => {
    const { subject, messages, hasFiles } = this.state;
    const { isReplyMessage } = this.props;
    const enableToSend = (isReplyMessage || isExist(subject)) && (isExist(messages) || hasFiles);

    this.setState({ enableToSend });
  };

  /**
   * Handle subject
   * @see {@link https://cxagroup.atlassian.net/browse/APL-4140}
   * @param {Proxy}  evt
   * @param {string} newValue
   */
  handleChangeSubject = (evt, newValue) =>
    this.setState(
      {
        subject: newValue,
      },
      this.checkFields
    );

  /**
   * Handle messages
   * @param {Proxy}  evt
   * @param {string} newValue
   */
  handleChangeMessages = (evt, newValue) =>
    this.setState(
      {
        messages: newValue,
      },
      this.checkFields
    );

  /**
   * Handle files
   * @param {?}     noIdea
   * @param {Array} files
   */
  handleChangeFiles = (noIdea, files) =>
    this.setState(
      {
        hasFiles: isExist(files),
      },
      this.checkFields
    );

  /**
   * Handle cancel button
   * @param {Proxy} evt
   */
  handleCancel = evt => {
    evt.preventDefault();

    const { reset, onCancel } = this.props;

    Promise.resolve(reset()).then(() =>
      this.setState(
        {
          subject: null,
          messages: null,
          hasFiles: false,
          enableToSend: false,
        },
        onCancel
      )
    );
  };
}

const enhance = compose(
  injectIntl,
  reduxForm({
    form: formName,

    onSubmit: (values, dispatch, props) => {
      const { parentMessage } = props;
      const messageData = isExist(parentMessage)
        ? {
            fkParentMessage: parentMessage.pkMessage,
            fkRootMessage: parentMessage.pkMessage,
            subject: parentMessage.subject,
          }
        : {
            fkParentMessage: 0,
            fkRootMessage: 0,
          };
      /**
       * Actually no need this code
       * but preventing act that press fast for 'send' button
       * @see {@link https://cxagroup.atlassian.net/browse/APL-4140}
       */
      if (isEmpty(values.subject) && isEmpty(messageData.subject)) {
        alert("Please enter the message subject");

        throw new SubmissionError({ _error: "There is no subject!" });
      }

      return postMessage(
        {
          ...values,
          ...messageData,
        },
        dispatch
      );
    },

    onSubmitSuccess: (result, dispatch, props) => {
      const { onPostMessageSuccess } = props;

      onPostMessageSuccess(result, dispatch, props);
    },

    enableReinitialize: true,
  })
);

export default enhance(ComposeMessageForm);



// WEBPACK FOOTER //
// ./components/inAppMessages/ComposeMessageForm.js